import Component from '@glimmer/component';
import { service } from '@ember/service';
import { tracked } from '@glimmer/tracking';
import { restartableTask, didCancel } from 'ember-concurrency';
import { modifier } from 'ember-modifier';
import { resolveMediaImageUrl } from '@linc-technologies/linced-common/utils/media-image-url';

// Renders nothing until a blob URL is resolved. Unlike AvatarImage, there is
// no gravatar/default-avatar fallback here -- this is for content images
// (badges, category badges, event images), not person/group avatars, so
// callers rely on this component rendering nothing when there is no media
// or the fetch fails.
export default class MediaImage extends Component {
  @service media;

  @tracked _loading = true;
  @tracked _resolvedUrl = null;

  get url() {
    if (this._loading) return null;
    return this._resolvedUrl;
  }

  // Resets loading state on mediaId/original change so a stale image doesn't
  // linger while the new one is fetched. A stable wrapper element in the
  // template holds this modifier so it isn't destroyed/recreated when the
  // rendered conditional flips.
  fetchOnMediaId = modifier((_element, [mediaId, original]) => {
    this._loading = true;
    this._resolvedUrl = null;
    this.fetchBlobTask.perform(mediaId, original);
  });

  fetchBlobTask = restartableTask(async (mediaId, original) => {
    try {
      const url = await resolveMediaImageUrl(this.media, mediaId, original);
      this._resolvedUrl = url;
      this._loading = false;
    } catch (e) {
      if (didCancel(e)) return;
      console.error('failed to fetch media image: ' + e);
      this._loading = false;
    }
  });
}
